module.exports = __webpack_public_path__ + "img/tag.83637bfd.svg";